import React, { useEffect, useState } from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { updateSalesAgentRatesApi, salesAgentByIdApi, approveOrRejectSalesAgentDocumentsApi, uploadFileApi, adminGetDriverDetailsById, updatePartnerProfileApi, adminGetAllUserList, savePartnerBankDetailsApi, updateDriverDocsApi, updateSalesAgentDocsApi, adminChangePartnerApprovalStatus, getFleetOwnerRideVehiclesApi, getFleetOwnerDriversApi, updatefleetOwnerDriverApi, updateFleetOwnerVehicleApi, getVehicleCategoryListApi, countryListApi, cityByCountryApi, getFleetCommissionsApi, updateFleetCommissionsApi } from '../../../../utils/ApiEndpointFunctions';
import toast from 'react-hot-toast';
import { useFormik } from 'formik';
import { bankDetailsInitialValue, bankDetailsValidationSchema, fleetOwnerDriverInitialValue, fleetOwnerDriverValidationSchema, profileDetailsInitialValue, profileValidationSchema, salesAgentInitialValues, salesAgentRatesValidationSchema } from '../../../common/Validation';
import DatePicker from "react-datepicker";
import Spinwheel from '../../../common/Spinwheel';
import { capitalizeWords, dateFormat } from '../../../../utils/HelperFuncitons';
import { S3_URL } from '../../../../utils/BaseUrl';
import ConfirmationModal from '../../../common/ConfirmationModal';
import CommonTable from '../../../common/Table/CommonTable';
import PdfSvgIcon from '../../../common/PdfSvgIcon';
import ImageViewModal from '../../../common/Modal/ImageViewModal';
import AddOrUpdateDetails from '../../../common/Modal/AddOrUpdateDetails';


const FleetOwnerDetails = () => {
    const params = useParams();
    const [id] = useState(params?.id)
    const [allDrivers, setAllDrivers] = useState([])
    const [editId, setEditId] = useState(null);
  const [newCommission, setNewCommission] = useState("");
    const [profileDetails, setProfiledetails] = useState({});
    const [salesAgentDetails, setSalesAgentDetails] = useState({});
    const [driverDetails, setDriverDetails] = useState({});
    const [vehicleDetails, setVehicleDetails] = useState([]);
    const [commissionList, setCommissionList] = useState([]);
    const [bankDetails, setBankDetails] = useState([]);
    const [bonusDetails, setBonusDetails] = useState([]);
    const [rateLoader, setRateLoader] = useState(false);
    const [loader, setLoader] = useState(true);
    const [activeTab, setActiveTab] = useState('profile');
    const [confirmStatus, setConfirmStatus] = useState({ status: "", userId: "", role: "salesAgent" });
    const [selectDocument, setSelectDocument] = useState({ status: "", keyName: "", validDate: "", restaurantId: "" });
    const [selectedImg, setSelectedImg] = useState("")
    const confirmationModalId2 = "confirmationModal2"
    const driverBankModal2 = "driverBankModal2"
    const [detailsType, setDetailsType] = useState({ type: "", loading: false })
    const [fileUpload, setFileUpload] = useState([])
    const [selectedDocument, setSelectedDocument] = useState({ id: null, type: null, loading: false })
    const [salesAgentDocuments, setSalesAgentDcuments] = useState({})
    const [list, setList] = useState([])
    const [driverList, setDriverList] = useState([])
    const [loading, setLoading] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams()
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(0);
    const [selectedDriver, setSelectedDriver] = useState(null);
    const [vehicleCategoryList, setVehicleCategoryList] = useState({ list: [], categoryId: "", modelId: "", makeId: "" })
     const [countryOptions, setCountryOptions] = useState([])
      const [cityOptions, setCityOptions] = useState([])


    useEffect(() => {
        console.log("driver details agent", driverDetails)
    }, [driverDetails])

    const filterCites = async (countryId) => {
        try {
            const res = await cityByCountryApi("", countryId);
            if (res.status === 200) {
                let cityOption = res.data?.data?.map(ele => ({
                    label: ele.name,
                    value: ele.id
                }));
                setCityOptions(cityOption);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const filterCountry = async (inputValue) => {
        try {
            const res = await countryListApi(inputValue);
            if (res.status === 200) {
                let countryOption = res.data?.data?.map(ele => ({
                    label: ele.name,
                    value: ele.id   
                }));
                setCountryOptions(countryOption);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        filterCites("")
        filterCountry("")
    }, []) 

    const fetchVehicleCategory = async (category = "", make = "", model = "") => {
        try {
            const res = await getVehicleCategoryListApi(id, category, make, model);
            if (res.status === 200) {
                setVehicleCategoryList({ ...vehicleCategoryList, list: res.data?.data?.categoryList });
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getListDetails = async (search = "") => {
        setLoading(true)
        try {
            const page = searchParams.get("page") || 1
            const res = await getFleetOwnerRideVehiclesApi(driverDetails.id, page, limit, search)
            if (res?.status == 200) {
                setLoading(false)
                setList(res.data?.data?.vehicles);
                setPage(Math.ceil(res.data?.data?.totalLength / limit));
            }
        } catch (error) {
            console.log(error);
            toast.error(error.response?.data?.message || error?.message)
        }
    }

    const getFleetOwnerDriverDetails = async () => {
        setLoading(true)
        try {
            const page = searchParams.get("page") || 1
            const res = await getFleetOwnerDriversApi(driverDetails.id, page, limit)
            if (res?.status == 200) {
                setLoading(false)
                setDriverList(res.data?.data?.drivers);
                setSelectedDriver(res.data?.data?.drivers)
                setPage(Math.ceil(res.data?.data?.totalLength / limit));
            }
        } catch (error) {
            console.log(error);
            toast.error(error.response?.data?.message || error?.message)
        }
    }
    const getFleetOwnerCommissions = async () => {
    setLoading(true);
    try {
        const res = await getFleetCommissionsApi(id);  // <-- API call
        if (res?.status === 200) {
            setLoading(false);
            setCommissionList(res.data?.data);   // commissions ka data state me
        }
    } catch (error) {
        console.error(error);
        toast.error(error.response?.data?.message || error?.message);
        setLoading(false);
    }
};

useEffect(() => {
   if (id) {
      getFleetOwnerCommissions();
   }
}, [id]);
console.log("commissionssssssssssssssssss", commissionList)

    //     useEffect(() => {
    //         console.log("driverrrrlistttttt",selectedDriver)
    //   }, [selectedDriver])

    useEffect(() => {
        if (driverDetails?.id) {
            getListDetails()
            getFleetOwnerDriverDetails()
        }
    }, [limit, searchParams.get("page"), driverDetails])

    //    useEffect(()=>{
    //        console.log("lisssttt",list)
    //    },[list])

    useEffect(() => {
        fetchVehicleCategory();
    }, [])

    const genderOptions = [
        { label: "Male", value: "male" },
        { label: "Female", value: "female" },
        { label: "Other", value: "other" },
    ]



    const handleChangeStatus = async () => {
        try {
            setLoader(true)
            await adminChangePartnerApprovalStatus(confirmStatus)
            await fetchDriverDetails();
            document.getElementById('confirmationModal').click()
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something Went Wrong")
            setLoader(false)
        }
    }
const handleEdit = (ele) => {
    setEditId(ele.id);
    setNewCommission(ele.commission);
  };

  const updateCommission = async (ele) => {
    try {
      const payload = {
        partnerUserId: ele.partnerUserId,
        vehicleId: ele.vehicleId,
        commission: Number(newCommission),
      };

      const res = await updateFleetCommissionsApi(payload);

      if (res?.status === 200 || res?.data?.status === 1) {
        setCommissionList((prev) =>
          prev.map((item) =>
            item.id === ele.id ? { ...item, commission: newCommission } : item
          )
        );
        setEditId(null); // input band
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleKeyDown = (e, ele) => {
    if (e.key === "Enter") {
      updateCommission(ele);
    }
  };
    // useEffect(() => {
    //     if (id) {
    //         fetchSalesAgentDetails();
    //     }
    // }, [id]);

    const toggleTab = (tab) => {
        setActiveTab(tab);
    };

    async function handleFileUpload(name, e, formik) {
        try {
            const file = e.target.files[0];
            if (file) {
                const formData = new FormData();
                formData.append("file", file);
                formData.append("type", "documents")
                setFileUpload([...fileUpload, name])
                const res = await uploadFileApi(formData)
                formik.setFieldTouched(name, true)
                if (res.status === 200 && res.data?.status === 1) {
                    formik.setFieldValue(name, res.data?.data);
                    toast.success("File uploaded");
                }
            }
        } catch (error) {
            formik.setFieldTouched(`image`, true)
            console.log(error)
            if (error?.response === undefined) {
                toast.error("File size is too large")
            }
        }
        setFileUpload([...fileUpload?.filter(ele => ele != name)])
    }

    const fetchDriverDetails = async () => {
        try {
            const res = await adminGetDriverDetailsById(id);
            if (res.status === 200) {
                console.log("driver fetch", res.data.data)
                const { id, role, phone, referralCode, driverDetails, partnerUserDetails, vehicles, bankDetails, driverBonus } = res.data.data;
                setDriverDetails({ id, phone, referralCode, role, ...driverDetails[0], ...partnerUserDetails[0] });
                setVehicleDetails(vehicles);
                setBankDetails(bankDetails)
                setBonusDetails(driverBonus)
            }
            // rateFormik.setValues({
            //     id: id,
            //     rewardPercentage: driverDetails?.rewardPercentage || '',
            //     from: driverDetails?.createdAt || null,
            //     to: driverDetails?.rewardExpiryDate || null,
            //     rewardOnOff: !!driverDetails?.rewardOnOff
            // });
            //         }
            //         setLoader(false);
            setLoader(false);
        } catch (error) {
            setLoader(false);
            console.log(error);
        }
    };

    const bankDetailsHeaderData = [
        { name: "Account Holder Namer", className: "list-sort text-muted", key: "name" },
        { name: "Bank Name", className: "list-sort text-muted", key: "bankName" },
        { name: "IFSC", className: "list-sort text-muted", key: "Ifsc" },
        { name: "Account Number", className: "list-sort text-muted", key: "accountNo" },
        { name: "Account Type", className: "list-sort text-muted", key: "accountType" },
        { name: <div className='d-flex gap-2 justify-content-center align-items-center'><div>Action</div><div>{!bankDetails?.length && <button className='btn btn-primary' data-bs-toggle="modal" data-bs-target={`#driverBankModal2`}>Add</button>}</div></div>, className: "col-1", key: "action" },
    ]

    const bankDetailsTableData = bankDetails?.map((bnk, index) => ({
        name: driverDetails.name || "",
        bankName: bnk.bankName || "",
        Ifsc: bnk.Ifsc || "",
        accountNo: bnk.accountNo || "",
        accountType: bnk.accountType || "",
        action: (
            // <span
            //   style={{ cursor: "pointer" }}
            //   data-bs-toggle="modal"
            //   data-bs-target={`#driverBankModal2`}
            //   onClick={() => {
            //     salesAgentDetailsFormik?.setValues({
            //       ...bnk,
            //       name: {
            //         label: salesAgentDetails?.name,
            //         value: salesAgentDetails?.name,
            //       },
            //     });
            //     setActiveTab("bankDetails");
            //   }}
            // >
            //   Edit
            // </span>
            <div className="dropdown">
                <button
                    className=" border-0 bg-white"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-three-dots-vertical"
                        viewBox="0 0 16 16">
                        <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
                    </svg>
                </button>
                <ul
                    className="dropdown-menu"
                    style={{ zIndex: "1000" }}>
                    <li
                        data-bs-toggle="modal"
                        data-bs-target={`#driverBankModal2`}
                        onClick={() => {
                            driverDetailsFormik?.setValues({
                                ...bnk,
                                name: {
                                    label: driverDetails?.name,
                                    value: driverDetails?.name,
                                },
                            });
                            setActiveTab("bankDetails");
                        }}
                    >
                        <a className="dropdown-item" href="#">
                            Edit
                        </a>
                    </li>
                </ul>
            </div>
        ),
    }))

    const profileData = [
        { name: "Email", data: driverDetails.email, },
        { name: "Phone", data: driverDetails.phone, },
        { name: "Alternate Phone", data: driverDetails.alternateMobile, },
        { name: "NIN", data: driverDetails.NIN, },
        { name: "Status", data: capitalizeWords(driverDetails.approvalStatus), },
        { name: "Role", data: driverDetails.role?.map(el => capitalizeWords(el))?.join(", "), },
        { name: "Gender", data: driverDetails.gender, },
        { name: "City", data: driverDetails.city, },
        { name: "State", data: driverDetails.state, },
        { name: "Country", data: driverDetails.country, },
        { name: "Zip Code", data: driverDetails.zip, },
        { name: "Address", data: <div>{driverDetails.permanentAddress && `${driverDetails.permanentAddress}, `}{driverDetails.state && `${driverDetails.state}, `}{driverDetails.city && `${driverDetails.city}, `}{driverDetails.zip && `${driverDetails.zip}`}</div>, },
        { name: "Referral Code", data: driverDetails.referralCode, },
    ]

    function handleInputChange(name, e, formik, input, type) {
        if (input == "input") {
            const { value } = e?.target
            if (type == "number" && isNaN(value)) return
            formik.setFieldValue(name, value)
        } else if (input == "date") {
            formik.setFieldValue(name, e)
        } else if (input == "select") {
            let list = [{ name, value: e }]
            if (name == "categoryId") {
                list.push({ name: "modelId", value: "" }, { name: "makeId", value: "" })
            } else if (name == "modelId") {
                list.push({ name: "makeId", value: "" })
            }

            list?.forEach(ele => {
                formik.setFieldValue(ele?.name, ele?.value)
            })
        } else if (input == "address") {
            formik.setFieldValue(name, e?.label)
        }

    }



    const openModal = () => {
        document.getElementById('confirmationModal2Btn').click()
    }

    async function handleDriverDetailSubmit(payload, apiEndPoint) {
        try {
            console.log("in try block")
            setDetailsType({ ...detailsType, loading: true })
            let res;
            if (activeTab === "driver") {
                res = await apiEndPoint({ ...payload })
            }
            res = await apiEndPoint({ ...payload, partnerUserId: id })
            if (res?.status == 200 || res?.status == 201) {
                fetchDriverDetails();
                if (activeTab === "document") {
                    await fetchDriverDetails()
                }
                document.getElementById(detailsFields[activeTab]?.modalId)?.click()
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something Went Wrong")
        }
        setDetailsType({ ...detailsType, loading: false })
    }


    async function handleDetailSubmit(payload, apiEndPoint) {
        try {
            console.log("in try block")
            setDetailsType({ ...detailsType, loading: true })
            const res = await apiEndPoint({ ...payload })
            if (res?.status == 200 || res?.status == 201) {
                fetchDriverDetails();
                document.getElementById(detailsFields[activeTab]?.modalId)?.click()
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something Went Wrong")
        }
        setDetailsType({ ...detailsType, loading: false })
    }


    useEffect(() => {
        if (id) {
            fetchDriverDetails();
        }
    }, [id]);

    // const handleDriverDetailsUpdate=async(values)=>{
    //   const {partnerUserId} = values;
    //   try {
    //     const response = await updatefleetOwnerDriverApi(partnerUserId,values)
    //       if (response.status === 200){
    //         toast.success("update success")

    //       }
    //   } catch (error) {
    //     console.log("something went wrong while updating driver")
    //     toast.error(error.message)
    //   }
    // }

    const detailsFields = {
        "bankDetails": {
            format: [
                { name: "bankName", label: "Bank Name", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "accountNo", label: "Account No", type: "input", handleOnChange: (...values) => handleInputChange(...values, "number") },
                { name: "accountType", label: "Account Type", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "Ifsc", label: "IFSC", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },

            ],
            initialvalue: bankDetailsInitialValue,
            validationSchema: bankDetailsValidationSchema,
            handleSubmit: (values) => handleDriverDetailSubmit(values, savePartnerBankDetailsApi),
            modalId: driverBankModal2
        },

        "profile": {
            format: [
                { name: "profileImage", label: "Profile image", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("profileImage"), handleFileUpload },
                { name: "name", label: "Name", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "alternateMobile", label: "Alternate mobile", type: "input", handleOnChange: (...values) => handleInputChange(...values, "number") },
                { name: "email", label: "Email", type: "input", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "NIN", label: "NIN", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                {
                    name: "country",
                    label: "Country",
                    type: "select",
                    options: countryOptions,
                    handleOnChange: (name, selectedOption, formik, type) => {
                        console.log("Country selectedOption: ", selectedOption);
                        formik.setFieldValue(name, selectedOption);
                        if (selectedOption?.value) {
                            filterCites(selectedOption.value);
                        }
                    }
                },

                {
                    name: "city",
                    label: "City",
                    type: "select",
                    options: cityOptions,
                    handleOnChange: (name, selectedOption, formik, type) => {
                        console.log("City selectedOption: ", selectedOption);
                        formik.setFieldValue(name, selectedOption);
                    }
                },
                 { name: "state", label: "State", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                  { name: "zip", label: "Zip", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "permanentAddress", label: "Permanent address", type: "address", handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "gender", label: "Gender", type: "select", options: genderOptions, handleOnChange: (...values) => handleInputChange(...values, "text") },
            ],
            initialvalue: fleetOwnerDriverInitialValue,
            validationSchema: fleetOwnerDriverValidationSchema,
            handleSubmit: (values) => handleDriverDetailSubmit({ ...values, gender: values?.gender?.value,country:values?.country?.label, city:values?.city?.label }, updatePartnerProfileApi),
            modalId: driverBankModal2
        },
        "document": {
            format: [
                ...(selectedDocument.type == "Driving Licence" ?
                    [
                        { name: "drivingLicence", label: "Driving Licence", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("drivingLicence"), handleFileUpload },
                        { name: "drivingLicenceValidUpto", label: "Valid upto", type: "date", handleOnChange: (...values) => handleInputChange(...values, "text") },
                    ] :
                    (selectedDocument.type == "National Id" ?
                        [
                            { name: "nationalId", label: "National Id", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("nationalId"), handleFileUpload },
                            // { name: "nationalId", label: "Valid upto", type: "date", handleOnChange: (...values) => handleInputChange(...values, "text") },
                        ] : [])

                ),
            ],
            initialvalue: profileDetailsInitialValue,
            // validationSchema:{},
            handleSubmit: (values) => {
                let preferredKeys = detailsFields[activeTab]?.format?.map(ele => ele?.name)
                let payload = {}
                preferredKeys?.map(ele => {
                    payload[ele] = values[ele]
                })
                //    console.log("preferredKeys", preferredKeys, payload);

                handleDriverDetailSubmit({ ...payload }, updateSalesAgentDocsApi)
            },
            modalId: driverBankModal2
        },
        "driver": {
            format: [
                { name: "profileImage", label: "Profile image", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("profileImage"), handleFileUpload },
                { name: "name", label: "Name", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "alternateMobile", label: "Alternate mobile", type: "phone", handleOnChange: (...values) => handleInputChange(...values, "phone") },
                { name: "email", label: "Email", type: "input", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "NIN", label: "NIN", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                 {
                    name: "country",
                    label: "Country",
                    type: "select",
                    options: countryOptions,
                    handleOnChange: (name, selectedOption, formik, type) => {
                        console.log("Country selectedOption: ", selectedOption);
                        formik.setFieldValue(name, selectedOption);
                        if (selectedOption?.value) {
                            filterCites(selectedOption.value);
                        }
                    }
                },

                {
                    name: "city",
                    label: "City",
                    type: "select",
                    options: cityOptions,
                    handleOnChange: (name, selectedOption, formik, type) => {
                        console.log("City selectedOption: ", selectedOption);
                        formik.setFieldValue(name, selectedOption);
                    }
                },
                 { name: "zip", label: "Zip", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "permanentAddress", label: "Permanent address", type: "address", handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "gender", label: "Gender", type: "select", options: genderOptions, handleOnChange: (...values) => handleInputChange(...values, "text") },
                //   { name: "driverStatus", label: "Status", type: "input", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
            ],
            initialvalue: fleetOwnerDriverInitialValue,
            validationSchema: fleetOwnerDriverValidationSchema,
            //    handleSubmit: (values) => console.log("valueeeeeeeeee",values),
            handleSubmit: (values) => handleDetailSubmit({ ...values, gender: values?.gender?.value,country:values?.country?.label, city:values?.city?.label }, updatefleetOwnerDriverApi),
            modalId: driverBankModal2
        },
        "vehicles": {
            format: [
                // { name: "profileImage", label: "Profile image", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("profileImage"), handleFileUpload },
                { name: "vehicleNumber", label: "Vehicle Number", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "partnerUserName", label: "Driver", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "categoryId", label: "Class", type: "select", options: vehicleCategoryList?.list?.filter((el, ind) => ind == vehicleCategoryList?.list.indexOf(vehicleCategoryList?.list?.filter((li, indx) => li?.id == el?.id)?.[0]))?.map(ele => { return { label: ele?.category, value: ele?.id } }), handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "modelId", label: "Modal", type: "select", options: vehicleCategoryList?.list?.filter((el, ind) => ind == vehicleCategoryList?.list.indexOf(vehicleCategoryList?.list?.filter((li, indx) => li?.modelId == el?.modelId)?.[0]))?.map(ele => { return { label: ele?.model, value: ele?.modelId } }), handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "makeId", label: "Type", type: "select", options: vehicleCategoryList?.list?.map(ele => { return { label: ele?.make, value: ele?.makeid } }), handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "vehicleImage", label: "Vehicle Image", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("profileImage"), handleFileUpload },
                { name: "vehicleCertificate", label: "Certificate", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("profileImage"), handleFileUpload },
                { name: "vehicleInsurance", label: "Insurance", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("profileImage"), handleFileUpload },
            ],
            initialvalue: fleetOwnerDriverInitialValue,
            validationSchema: fleetOwnerDriverValidationSchema,
            //    handleSubmit: (values) => console.log("submit",values),
            handleSubmit: (values) => handleDetailSubmit({ ...values, categoryId: values?.categoryId?.value, makeId: values?.makeId?.value, modelId: values?.modelId?.value }, updateFleetOwnerVehicleApi),
            modalId: driverBankModal2
        },

    }

    const driverDetailsFormik = useFormik({
        initialValues: detailsFields?.[activeTab]?.initialvalue,
        validationSchema: detailsFields?.[activeTab]?.validationSchema,
        enableReinitialize: true,
        onSubmit: detailsFields?.[activeTab]?.handleSubmit
    })

    // console.log("details",detailsFields?.[activeTab])
    // console.log("?????????????????",driverDetailsFormik.errors)
    //   const salesAgentDetailsFormik = useFormik({
    //         initialValues:detailsFields?.[activeTab]?.initialvalue,
    //         validationSchema:detailsFields?.[activeTab]?.validationSchema,
    //         enableReinitialize: true,
    //         onSubmit:detailsFields?.[activeTab]?.handleSubmit
    //     })



    const handleChangeDocumentStatus = async () => {
        const promise = approveOrRejectSalesAgentDocumentsApi({ userId: id, keyName: selectDocument.keyName, status: selectDocument.status, restaurantId: selectDocument.restaurantId });
        toast.promise(
            promise,
            {
                loading: 'Updating document status...',
                success: (res) => {
                    if (res.status === 200) {
                        driverDetails.approvalStatus = res.data.salesAgentStatus
                        setDriverDetails({ ...driverDetails, [selectDocument.keyName]: res.data.docStatus })
                        return res.data.message || 'Success';
                    }
                },
                error: (err) => {
                    return err.message || 'Something Went Wrong'
                }
            }
        )
    };

    const DocumentDisplay = ({ title, document, setSelectedImg, status, keyName, validUpto, number, restaurantId }) => {

        if (!document) {
            return (
                <tr>
                    <td>{title}</td>
                    <td className='text-center'>{`${title} not available`}</td>
                </tr>
            );
        }

        const isPdf = document ? document.split(".").slice(-1)[0] === "pdf" : "";

        return (
            <tr>
                <td>{title}</td>
                <td className='text-center'>
                    {isPdf ? (
                        <Link to={`${S3_URL}/${document}`} className="text-primary">
                            <PdfSvgIcon width="100" height="100" />
                        </Link>
                    ) : (
                        <img
                            src={`${S3_URL}/${document}`}
                            alt={title}
                            data-bs-toggle="modal"
                            data-bs-target={`#imageViewModal`}
                            style={{ cursor: 'pointer', maxWidth: '100%', maxHeight: '100px', borderRadius: "8%" }}
                            onClick={() => setSelectedImg(`${S3_URL}/${document}`)}
                        />
                    )}
                </td>
                <td className='text-center'>{validUpto ? dateFormat(validUpto) : ""}</td>
                <td className='text-center'>{capitalizeWords(status) || "-"}</td>
                {status !== "pending" && <td className='text-center'>
                    <div className="dropdown">
                        <button
                            className=" border-0 bg-white"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-three-dots-vertical"
                                viewBox="0 0 16 16"
                            >
                                <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
                            </svg>
                        </button>
                        <ul
                            className="dropdown-menu"
                            style={{ zIndex: "1000" }}
                        >
                            {(status === "rejected" || status === "submitted") && <li
                                onClick={() => {

                                    setSelectDocument({ status: 'approved', keyName: keyName, validDate: validUpto, restaurantId: restaurantId })
                                    openModal()
                                }}
                            >
                                <a className="dropdown-item" href="#">
                                    Approve
                                </a>
                            </li>}

                            {(status === "approved" || status === "submitted") && <li
                                onClick={() => {
                                    setSelectDocument({ status: 'rejected', keyName: keyName, validDate: validUpto, restaurantId: restaurantId })
                                    openModal()
                                }}
                            >
                                <a className="dropdown-item" href="#">
                                    Reject
                                </a>
                            </li>}

                            <li data-bs-toggle="modal" data-bs-target={`#${driverBankModal2}`} onClick={() => {
                                setSelectedDocument({ ...selectedDocument, type: title });
                                driverDetailsFormik?.setValues({
                                    ...driverDetails,
                                    name: {
                                        label: salesAgentDocuments?.name,
                                        value: salesAgentDocuments?.name,
                                    },
                                });
                                setActiveTab("document")
                            }}>
                                <a className="dropdown-item" href="#">
                                    Edit
                                </a>
                            </li>
                        </ul>
                    </div>
                </td>}
            </tr>
        );
    };


    const tabData = [
        {
            name: "Profile Details", tab: "profile", setTab: toggleTab, data: <div className="row card">
                {/* set tab here */}
                <div className="row mt-3">
                    <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary' onClick={() => driverDetailsFormik.setValues({ ...driverDetails, gender: { label: capitalizeWords(driverDetails?.gender), value: driverDetails?.gender }, country: { label: capitalizeWords(driverDetails?.country), value: driverDetails?.country }, city: { label: capitalizeWords(driverDetails?.city), value: driverDetails?.city }   })} data-bs-toggle="modal" data-bs-target={`#driverBankModal2`}>Edit</button>
                    </div>
                    <div className="user-details">
                        <table className="table table-md table-hover card-table">
                            <tbody>
                                {
                                    profileData.map((ele, index) => (
                                        <tr key={index}>
                                            <td>{ele.name}:</td>
                                            <td>{ele.data}</td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        },
        { name: "Bank Details", tab: "bankDetails", setTab: toggleTab, data: <div className='p-3 card'><CommonTable headers={bankDetailsHeaderData} data={bankDetailsTableData} /></div> },
        // {
        //     name: "Rate", tab: "rate", setTab: toggleTab, data:
        //         <div className="card">
        //             <div className="card-header" style={{ backgroundColor: "var(--color-card-bg)" }}>
        //                 Rate
        //             </div>
        //             <div className="card-body" >
        //                 <div className='p-5'>
        //                     <form onSubmit={rateFormik.handleSubmit}>
        //                         <div className="form-group row row-cols-4">
        //                             <div className='d-flex gap-3'>
        //                                 <label htmlFor='deliveryFee' className=" col-form-label">Reward Percentage fee</label>
        //                                 <div className="">
        //                                     <input type="text" className="form-control" id='rewardPercentage' name='rewardPercentage' placeholder="0" onChange={rateFormik.handleChange} onBlur={rateFormik.handleBlur} value={rateFormik.values.rewardPercentage} />
        //                                     {rateFormik.touched?.rewardPercentage && rateFormik.errors?.rewardPercentage ? (<div className='req-error'>{rateFormik?.errors?.rewardPercentage}</div>) : null}
        //                                 </div>
        //                             </div>

        //                             <div className='d-flex gap-3'>
        //                                 <label htmlFor='from' className=" col-form-label">From</label>
        //                                 <div className="">
        //                                     <DatePicker
        //                                         className='form-control'
        //                                         name="from"
        //                                         disabled
        //                                         dateFormat={"dd/MM/yyyy"}
        //                                         selected={
        //                                             rateFormik.values?.from && !isNaN(new Date(rateFormik.values?.from))
        //                                                 ? new Date(rateFormik.values.from)
        //                                                 : null
        //                                         }
        //                                         onChange={(date) => { rateFormik.setFieldValue("from", date) }}
        //                                     />

        //                                     {rateFormik.touched?.from && rateFormik.errors?.from ? (<div className='req-error'>{rateFormik?.errors?.from}</div>) : null}
        //                                 </div>
        //                             </div>

        //                             <div className='d-flex gap-3'>
        //                                 <label htmlFor='deliveryFee' className=" col-form-label">To</label>
        //                                 <div className="">
        //                                     <DatePicker
        //                                         className='form-control'
        //                                         name='to'
        //                                         dateFormat={"dd/MM/yyyy"}
        //                                         placeholderText='dd/MM/yyyy'
        //                                         selected={
        //                                             rateFormik.values?.to && !isNaN(new Date(rateFormik.values?.to))
        //                                                 ? new Date(rateFormik.values.to)
        //                                                 : null
        //                                         }
        //                                         onChange={(date) => { rateFormik.setFieldValue("to", date) }}
        //                                     />

        //                                     {rateFormik.touched?.rewardPercentage && rateFormik.errors?.rewardPercentage ? (<div className='req-error'>{rateFormik?.errors?.rewardPercentage}</div>) : null}
        //                                 </div>
        //                             </div>

        //                             <div className='d-flex align-items-center gap-3'>
        //                                 <label htmlFor='rewardOnOff' className=" col-form-label">Reward (on/off)</label>
        //                                 <div className="form-check form-switch">
        //                                     <input className="form-check-input" type="checkbox" role="switch" checked={rateFormik?.values?.rewardOnOff} id="rewardOnOff" onChange={() => rateFormik?.setFieldValue("rewardOnOff", !Boolean(rateFormik?.values?.rewardOnOff))} />
        //                                     {rateFormik.touched?.rewardOnOff && rateFormik.errors?.rewardOnOff ? (<div className='req-error'>{rateFormik?.errors?.rewardOnOff}</div>) : null}
        //                                 </div>
        //                             </div>


        //                             <div className="d-flex align-items-end"  >
        //                                 <button type="submit" className="btn btn-sm btn-primary" disabled={rateLoader}>Submit</button>
        //                             </div>
        //                         </div>
        //                     </form>
        //                 </div>
        //             </div>
        //         </div>
        // },
        {
            name: "Documents", tab: "document", setTab: toggleTab, data: <div className="row card ">
                <div className="mt-3 table-responsive  " style={{ overflowX: "inherit" }}>
                    <table className="table table-md table-hover card-table">
                        <thead>
                            <tr>
                                <th> <span className="list-sort text-muted">Type</span></th>
                                <th className='text-center'> <span className="list-sort text-muted">File</span></th>
                                <th className='text-center'> <span className="list-sort text-muted">Valid Upto</span></th>
                                <th className='text-center'> <span className="list-sort text-muted">Status</span></th>
                                <th className='text-center'> <span className="list-sort text-muted">Action</span></th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* <DocumentDisplay
                                title="Driving Licence"
                                document={driverDetails?.drivingLicence}
                                setSelectedImg={setSelectedImg}
                                status={driverDetails?.drivingLicenceApprovalStatus}
                                keyName={"drivingLicenceApprovalStatus"}
                                validUpto={driverDetails?.drivingLicenceValidUpto}
                            /> */}
                            <DocumentDisplay
                                title="National Id"
                                document={driverDetails?.nationalId}
                                setSelectedImg={setSelectedImg}
                                status={driverDetails?.nationalIdApprovalStatus}
                                keyName={"nationalIdApprovalStatus"}
                            />
                        </tbody>
                    </table>
                </div>
            </div>
        },
        {

            name: "Vehicles", tab: "vehicles", setTab: toggleTab, data: <div className="row card ">
                <div className="mt-3 table-responsive  " style={{ overflowX: "inherit" }}>
                    <table className="table table-md table-hover card-table">
                        <thead>
                            <tr>
                                <th className='text-center'> <span className="list-sort text-muted">SN.</span></th>
                                <th className='text-center'> <span className="list-sort text-muted">vehicleNumber</span></th>
                                <th className='text-center'> <span className="list-sort text-muted">Driver</span></th>
                                <th className='text-center'> <span className="list-sort text-muted">Category</span></th>
                                <th className='text-center'> <span className="list-sort text-muted">Modal</span></th>
                                <th className='text-center'> <span className="list-sort text-muted">Make</span></th>
                                <th className='text-center'> <span className="list-sort text-muted">Vehicle image</span></th>
                                <th className='text-center'> <span className="list-sort text-muted">Certificate</span></th>
                                <th className='text-center'> <span className="list-sort text-muted">Insurance</span></th>
                                <th className='text-center'> <span className="list-sort text-muted">Action</span></th>
                            </tr>
                        </thead>
                        <tbody>
                            {console.log("////", list)}
                            {
                                list.map((ele, index) => (
                                    <tr key={index}>
                                        <td className='text-center'>{index + 1}</td>
                                        <td className='text-center'>{ele.vehicleNumber}</td>
                                        <td className='text-center'>{ele.partnerUserName}</td>
                                        <td className='text-center'>{ele.category}</td>
                                        <td className='text-center'>{ele.model}</td>
                                        <td className='text-center'>{ele.make}</td>
                                        {/* <td>{ele.vehicleImage}</td> */}
                                        <td className='text-center'><img src={S3_URL + "/" + ele.vehicleImage} alt="vehicleImage" width="100px" /></td>
                                        {/* {console.log("fdfdf",S3_URL+ele.vehicleImage)} */}
                                        {/* <td>{ele.vehicleCertificate}</td> */}
                                        <td className='text-center'><img src={S3_URL + "/" + ele.vehicleCertificate} alt="vehicleImage" width="100px" /></td>
                                        {/* <td>{ele.vehicleInsurance}</td> */}
                                        <td className='text-center'><img src={S3_URL + "/" + ele.vehicleInsurance} alt="vehicleImage" width="100px" /></td>
                                        <td>
                                            <div className="dropdown">
                                                <button
                                                    className=" border-0 bg-white"
                                                    type="button"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                >
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="16"
                                                        height="16"
                                                        fill="currentColor"
                                                        className="bi bi-three-dots-vertical"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
                                                    </svg>
                                                </button>
                                                <ul className="dropdown-menu" style={{ zIndex: "1000" }}>
                                                    {console.log("//////////////////////////s", ele)}
                                                    <li
                                                        data-bs-toggle="modal"
                                                        data-bs-target={`#${driverBankModal2}`}
                                                        onClick={() => {
                                                            driverDetailsFormik?.setValues({
                                                                ...ele,
                                                                id: ele?.id,
                                                                phone: ele?.phone,
                                                                categoryId: { label: ele?.category, value: ele?.categoryId },
                                                                makeId: { label: ele?.make, value: ele?.makeId },
                                                                modelId: { label: ele?.model, value: ele?.modelId },
                                                                // name: {
                                                                //     label: ele?.partnerUserDetails?.[0]?.name,
                                                                //     value: ele?.partnerUserDetails?.[0]?.name,
                                                                // },
                                                            });
                                                            setActiveTab("vehicles");
                                                        }}
                                                    >
                                                        <a className="dropdown-item" href="#">Edit</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </div>

        },
        {

            name: "Drivers", tab: "driver", setTab: toggleTab, data: <div className="row card ">
                <div className="mt-3 table-responsive  " style={{ overflowX: "inherit" }}>
                    <table className="table table-md table-hover card-table">
                        <thead>
                            <tr>
                                <th className='text-center'> <span className="list-sort text-muted">SN.</span></th>
                                <th className='text-center'> <span className="list-sort text-muted">Name</span></th>
                                <th className='text-center'> <span className="list-sort text-muted">Phone</span></th>
                                <th className='text-center'> <span className="list-sort text-muted">Gender</span></th>
                                <th className='text-center'> <span className="list-sort text-muted">NIN</span></th>
                                <th className='text-center'> <span className="list-sort text-muted">Status</span></th>
                                <th className='text-center'> <span className="list-sort text-muted">Action</span></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                driverList?.map((ele, index) => (
                                    <tr key={index}>
                                        {/* {console.log("kyaaaaaaaaaaaaaaaaaaa",ele?.partnerUserDetails?.[0])} */}
                                        <td className='text-center'>{index + 1}</td>
                                        <td className='text-center'>{ele?.partnerUserDetails?.[0]?.name}</td>
                                        <td className='text-center'>{ele.phone}</td>
                                        <td className='text-center'>{ele?.partnerUserDetails?.[0]?.gender}</td>
                                        <td className='text-center'>{ele?.partnerUserDetails?.[0]?.NIN}</td>
                                        <td className='text-center'>{ele.driverDetails?.[0]?.driverStatus}</td>
                                        <td>
                                            <div className="dropdown">
                                                <button
                                                    className=" border-0 bg-white"
                                                    type="button"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                >
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="16"
                                                        height="16"
                                                        fill="currentColor"
                                                        className="bi bi-three-dots-vertical"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
                                                    </svg>
                                                </button>
                                                <ul className="dropdown-menu" style={{ zIndex: "1000" }}>
                                                    {console.log("//////////////////////////", ele?.partnerUserDetails?.[0])}
                                                    <li
                                                        data-bs-toggle="modal"
                                                        data-bs-target={`#${driverBankModal2}`}
                                                        onClick={() => {
                                                            driverDetailsFormik?.setValues({
                                                                ...ele?.partnerUserDetails?.[0],
                                                                id: ele?.id,
                                                                phone: ele?.phone,
                                                                driverStatus: ele?.driverDetails?.[0]?.driverStatus,
                                                                gender: {
                                                                    label: capitalizeWords(ele?.partnerUserDetails?.[0]?.gender),
                                                                    value: ele?.partnerUserDetails?.[0]?.gender
                                                                },
                                                                country: {
                                                                    label: ele?.partnerUserDetails?.[0]?.country,
                                                                    value: ele?.partnerUserDetails?.[0]?.country,
                                                                },
                                                                 city: {
                                                                    label: ele?.partnerUserDetails?.[0]?.city,
                                                                    value: ele?.partnerUserDetails?.[0]?.city,
                                                                },
                                                            });
                                                            setActiveTab("driver");
                                                        }}
                                                    >
                                                        <a className="dropdown-item" href="#">Edit</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </td>
                                    </tr>

                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </div>

        },
        {
  name: "Rate",
  tab: "rate",
  setTab: toggleTab,
  data: (
    <div className="row card">
      <div className="mt-3 table-responsive" style={{ overflowX: "inherit" }}>
        <table className="table table-md table-hover card-table">
          <thead>
            <tr>
              <th className="text-center">SN.</th>
              <th className="text-center">Category</th>
              <th className="text-center">Make</th>
              <th className="text-center">Model</th>
              <th className="text-center">Commission (%)</th>
            </tr>
          </thead>
          <tbody>
            {commissionList && commissionList.length > 0 ? (
              commissionList.map((ele, index) => (
                <tr key={ele.id}>
                  <td className="text-center">{index + 1}</td>
                  <td className="text-center">{ele.category}</td>
                  <td className="text-center">{ele.make}</td>
                  <td className="text-center">{ele.model}</td>
                 <td className="text-center">
                {editId === ele.id ? (
                  <div className="d-flex justify-content-center align-items-center">
                    <input
                      type="number"
                      className="form-control"
                      value={newCommission}
                      autoFocus
                      onChange={(e) => setNewCommission(e.target.value)}
                      onKeyDown={(e) => handleKeyDown(e, ele)}
                      style={{ width: "80px", display: "inline-block" }}
                    />
                    <button
                      className="btn btn-sm btn-success ms-2"
                      onClick={() => updateCommission(ele)}
                    >
                      <i className="bi bi-check2"></i>
                    </button>
                  </div>
                ) : (
                  <>
                    {ele.commission}{" "}
                    <i
                      className="bi bi-pencil-square text-primary ms-2"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleEdit(ele)}
                    ></i>
                  </>
                )}
              </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center">
                  No commissions found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  ),
},
    ]

    // console.log("ddddddddddddddddddddddddddddddddddd",driverDetails)

    return (
        <div className="main-content">
            <div className="container-fluid">

                {loader ? (
                    <div className="text-center">
                        <Spinwheel />
                    </div>
                ) : (
                    <>
                        <div className="row align-items-end">
                            <div className="col-auto">
                                <div className="avatar avatar-xxl header-avatar-top mt-3">
                                    <img src={driverDetails?.profileImage ? `${S3_URL}/${driverDetails?.profileImage}` : "https://img.freepik.com/premium-vector/man-avatar-profile-picture-vector-illustration_268834-538.jpg"} alt="profile" className="avatar-img rounded-circle border border-4 border-body" />
                                </div>
                            </div>
                            <div className="col mb-3 ms-n3 ms-md-n2">
                                <h1 className="header-title">
                                    {capitalizeWords(driverDetails.name)}
                                </h1>
                            </div>
                            <div className="col-12 col-md-auto mt-2 mt-md-0 mb-md-3">
                                {(driverDetails.approvalStatus === "pending") ? <><button type="button" className="btn btn-outline-primary me-2" data-bs-toggle="modal"
                                    data-bs-target={`#confirmationModal`}
                                    onClick={(e) => { setConfirmStatus(prevState => ({ ...prevState, status: "approved", userId: id })) }}>Approve</button>
                                    <button type="button" className="btn btn-outline-secondary" data-bs-toggle="modal"
                                        data-bs-target={`#confirmationModal`}
                                        onClick={(e) => { setConfirmStatus(prevState => ({ ...prevState, status: "rejected", userId: id })) }}>Reject</button></> :
                                    <div className={`badge fs-4  ${driverDetails.approvalStatus === "approved" ? "bg-primary-soft" : "bg-secondary-soft"}`}>{capitalizeWords(driverDetails.approvalStatus)}</div>
                                }
                            </div>
                        </div>

                        <div className='d-flex justify-content-between'>
                            <ul className="nav nav-tabs">
                                {
                                    tabData.map((ele, index) => (
                                        <li className="nav-item">
                                            <button
                                                className={`nav-link ${activeTab === ele.tab ? 'active' : ''}`}
                                                onClick={() => ele.setTab(ele.tab)}
                                            >
                                                {ele.name}
                                            </button>
                                        </li>
                                    ))
                                }
                            </ul>
                            <div>
                            </div>
                        </div>
                        {
                            tabData.map((ele) => (
                                activeTab === ele.tab ? ele.data : null
                            ))
                        }
                    </>
                )}
                {/* {console.log("zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzz",detailsFields[activeTab]?.format)} */}

                <ConfirmationModal
                    handleConfirm={handleChangeStatus}
                    confirmStatus={confirmStatus}
                />
                <ImageViewModal imgUrl={selectedImg} modalId={"imageViewModal"} />
                <button id="confirmationModal2Btn" className='d-none' data-bs-toggle="modal" data-bs-target={`#${confirmationModalId2}`}></button>
                <ConfirmationModal modalId={confirmationModalId2} message={<> Do you want to continue?</>} handleConfirm={() => handleChangeDocumentStatus()} title={"Warning!"} confirmStatus={""} />
                {console.log("driver formik", driverDetailsFormik.values)}
                {/* {console.log("format",detailsFields[activeTab]?.format)} */}
                <AddOrUpdateDetails formik={driverDetailsFormik} dataFormat={detailsFields[activeTab]?.format} detailsFor={detailsType?.type} addLoader={detailsType?.loading} modalId={driverBankModal2} />

            </div>
        </div>

    );
};

export default FleetOwnerDetails;